<template>
  <v-container fluid grid-list-xl>
    <v-layout row wrap>
      <v-flex xs12>
        <h1>
          {{ service.name }}
        </h1>
        <h1>
          {{ $tc('models.servicePrice', 2) }}
          <v-btn color="primary" @click="goTo('newServicePrice', { serviceId: $route.params.serviceId })"> {{ $t('create') }} </v-btn>
          <v-btn color="primary" @click="pickFile"> {{ $t('importExcel') }} </v-btn>
          <v-btn text color="primary" link href="https://hydraship-co-demo.s3.us-west-2.amazonaws.com/service-prices.xlsx" target="_blank"> {{ $t('downloadExample') }} </v-btn>

          <v-btn color="primary" outline @click="back"> {{ $t('back') }} </v-btn>

          <input type="file" style="display: none" ref="file" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" @change="onFilePicked">
        </h1>
      </v-flex>

      <v-flex xs12>
        <v-data-table class="elevation-1"
          :headers="headers"
          :items="items"
          :loading="loading"
          hide-actions
          :no-data-text="$t('noDataAvailable')">
          <v-progress-linear v-slot:progress color="primary" indeterminate></v-progress-linear>
          <template v-slot:items="props">
            <td> {{ props.item.kg }} </td>
            <td> {{ props.item.price | currency }} </td>
            <td v-if="!service.use_quoted_rates"> {{ props.item.admin_cost | currency }} </td>
            <td v-if="showMainAdminCost"> {{ props.item.main_admin_cost | currency }} </td>
            <td class="pa-0 pr-2 text-xs-right">

              <v-btn color="primary" flat icon @click="goTo('editServicePrice', { serviceId: $route.params.serviceId, id: props.item.id })">
                <font-awesome-icon icon="edit"></font-awesome-icon>
              </v-btn>

              <v-btn color="error" flat icon @click="destroy(props.item)">
                <font-awesome-icon icon="times"></font-awesome-icon>
              </v-btn>

            </td>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import XLSX from 'xlsx'

import Service from '@/client/service'
import ServicePrice from '@/client/service-price'

export default {
  name: 'ServicePricesView',

  props: {},

  data () {
    return {
      items: [],
      loading: false,
      service: {},
    }
  },

  components: {
  },

  computed: {
    showMainAdminCost() {
      return (this.$auth.isMainAdmin() || this.$auth.isDev()) && !this.service.use_quoted_rates
    },

    headers () {
      let h = [
        { text: 'KG', align: 'left', sortable: true, value: 'kg' },
        { text: this.$t('attrs.price'), align: 'left', sortable: true, value: 'price' },
      ]

      if (!this.service.use_quoted_rates) {
        h.push({ text: this.$t('cost'), align: 'left', sortable: true, value: 'admin_cost' })
      }
      if (this.showMainAdminCost) {
        h.push({ text: this.$t('main_admin_cost'), align: 'left', sortable: true, value: 'main_admin_cost' })
      }
      h.push({ text: '', align: 'left', sortable: false, value: '' })

      return h
    },
  },

  methods: {
    async fetch () {
      if (!this.service.id) { return }

      this.loading = true
      this.items = await ServicePrice.all({
        where: {
          service_id: this.service.id
        },
        per_page: 2000
      })

      this.loading = false
    },

    async destroy (servicePrice) {
      try {
        await ServicePrice.destroyById(servicePrice.id)
        this.fetch()
      } catch (err) {
        this.handleErr(err)
      }
    },

    pickFile () {
      this.$refs.file.click()
    },

    onFilePicked (e) {
      const file = e.target.files[0]
      const self = this

      const reader = new FileReader()
      reader.onload = (e) => {
        const data = e.target.result
        const wb = XLSX.read(data, { type: 'binary' })
        wb.SheetNames.forEach(sn => {
          let res = XLSX.utils.sheet_to_json(wb.Sheets[sn])
          const prices = res.map(row => {
            const price = new ServicePrice({
              service_id: this.service.id,
              kg: row.kg,
              price: row.price,
              admin_cost: row.cost,
              main_admin_cost: 0
            })
            return price.save()
          })

          Promise.all(prices).then(() => self.fetch())
        })
      }

      reader.readAsBinaryString(file)
    },
  },

  watch: {
  },

  async mounted () {
    this.service = await Service.findOne(this.$route.params.serviceId)
    this.fetch()
  }
}
</script>
